import { AUTHEN } from '../actions';

const initialState = {
  isAuthenticated: false,
  loginFetching: false,
  loginUser: null,
  loginError: false,
  loginErrorData: null,
  loggedIn: true,
  user: {
    first_name: 'Shen',
    last_name: 'Zhi',
    email: 'demo@devias.io',
    avatar: '/images/avatars/avatar_11.png',
    bio: 'Brain Director',
    role: 'ADMIN' // ['GUEST', 'USER', 'ADMIN']
  }
};

export default (state = initialState, { type, payload, error }) => {
  switch (type) {
    case AUTHEN.CHECK_JWT_SUCCESS:
      return { ...state, isAuthenticated: true, loginUser: payload };

    case AUTHEN.CHECK_JWT_FAILED:
      return { ...state, isAuthenticated: false, loginUser: null };

    case AUTHEN.LOGIN_PENDING:
      return {
        ...state,
        isAuthenticated: false,
        loginFetching: true,
        loginUser: null,
        loginError: false,
        loginErrorData: null
      };

    case AUTHEN.LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        loginFetching: false,
        loginUser: payload
      };

    case AUTHEN.LOGIN_FALIED:
      return {
        ...state,
        isAuthenticated: false,
        loginFetching: false,
        loginUser: null,
        loginError: true,
        loginErrorData: error
      };

    default:
      return state;
  }
};
